<template>
  <transition name="fade">
    <div class="overlay" v-bind:class = "{page: loadingStore.type === 'page', form: loadingStore.type ==='form'}" v-if="loadingStore.isLoading">
      <div v-if = "loadingStore.type === 'page'" class="spinner"></div>
      <div v-if = "loadingStore.type === 'form'" class="ring"><div></div><div></div><div></div><div></div></div>
    </div>
  </transition>
</template>

<script>
import { LoadingStore } from "@/store/LoadingStore.js";
export default {
  props: {
    type: String,
    isLoading: Boolean
  },
  data () {
    return {
      loadingStore: LoadingStore()
    }
  },
  name: 'Spinner',
  computed:{
    link() {
      return `this ${this.type}`;
    }
  }
}
</script>

<style scoped>
  .page {
    background-color: #1979CF;
  }

  .form {
    background-color: rgba(0,0,0,0.5);
  }

  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: white;
    min-height: stretch;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: 9999;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s ease-out;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  /* ----------------------------------------------
   * Page loading
   * Generated by Animista
   * w: http://animista.net, t: @cssanimista
   * ---------------------------------------------- */
  .spinner {
    background-image: url('../assets/att_globe_rgb_wht.png');
    background-size: cover;
    height: 25rem;
    width: 25rem;
    -webkit-animation: rotate-vert-center 1s infinite cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
    animation: rotate-vert-center 1s infinite cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
  }
  @-webkit-keyframes rotate-vert-center {
    0% {
      -webkit-transform: rotateY(0);
      transform: rotateY(0);
    }
    100% {
      -webkit-transform: rotateY(360deg);
      transform: rotateY(360deg);
    }
  }
  @keyframes rotate-vert-center {
    0% {
      -webkit-transform: rotateY(0);
      transform: rotateY(0);
    }
    100% {
      -webkit-transform: rotateY(360deg);
      transform: rotateY(360deg);
    }
  }

  /* -----------------------------------------------
   * Submission loading
   * ----------------------------------------------- */
  .ring {
    display: inline-block;
    position: relative;
    width: 6rem;
    height: 6rem;
  }
  .ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 5rem;
    height: 5rem;
    margin: 0.5rem;
    border: 0.5rem solid #fff;
    border-radius: 50%;
    animation: ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
  }
  .ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>